import { useQuery } from "react-query";
import { queryKey } from "@/store/queryKeys";
import { constants } from "@/constants";

export const modelsListQuery = () => {
    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: queryKey.modelsList,
        queryFn: async () => {
            return fetch(`${constants.url.API_PREFIX}models`).then((response) =>
                response.json(),
            );
        },
    });
};

export const modelsImageListQuery = () => {
    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: queryKey.modelsImageList,
        queryFn: async () => {
            return fetch(`${constants.url.API_PREFIX}images/models`).then((response) =>
              response.json(),
            );
        },
    });
};